import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiPostOpenWaitlist } from '@/apis/serviceArea/postOpenWaitlist'

import { SERVICE_AREA_KEYS } from '../keys/serviceArea'

/**
 * 오픈 알림 신청 mutation.
 *
 * "오픈 요청하기" CTA에서 호출. 성공 시 해당 주소의 WAITLIST_STATUS 캐시를 invalidate
 * → useGetOpenWaitlist가 자동 refetch → UI(카운터, 버튼 상태) 즉시 갱신.
 *
 * 에러는 호출자(컴포넌트)의 onError 또는 mutation.error로 처리.
 */
export const usePostOpenWaitlist = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: apiPostOpenWaitlist,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [SERVICE_AREA_KEYS.WAITLIST_STATUS, variables.address],
      })
    },
  })
}
